import type { Middleware } from '@nuxt/types';

const promoSetter: Middleware = ({
  route: {
    name,
    params: { community, post },
    query: { promo },
  },
  store,
}) => {
  const isFeed = name && name.indexOf('feed') === 0;
  const isPortfolio = name && name.indexOf('portfolio') === 0;

  if (isFeed) {
    const feedPromoPefix = 'COMMUNITY';
    const feedPromo = `${feedPromoPefix}${community ? `-${community}` : ''}${post ? `--${post}` : ''}`;
    store.commit('setPromo', feedPromo);
  } else if (isPortfolio) {
    store.commit('setPromo', 'PORTFOLIO');
  } else if (promo) {
    store.commit('setPromo', (promo as string).toUpperCase());
  }
};

export default promoSetter;
